// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o1Og27Rz6NSbTNhQKoZv {
  width: 100%;
  background-color: var(--white);
}

.U31k8h2WgzfDuYVya4vA {
  padding: 0 var(--horizontal-padding);
  max-width: 90rem;
  margin: 5.625rem auto 0 auto;
}

.zGYj5VVBBm7xLlN83wAZ {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: minmax(6.25rem, 14.0625rem);
  grid-column-gap: 2.5rem;
  grid-row-gap: 3rem;
  margin: 3rem 0;
}

.X4hC6ZilcvtZIdFdz9D6 {
  color: var(--primary-link-color);
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5rem;
}

@media only screen and
  (min-width: 1280px) {
  .U31k8h2WgzfDuYVya4vA {
    --horizontal-padding: 4rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .U31k8h2WgzfDuYVya4vA {
    --horizontal-padding: 3rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .U31k8h2WgzfDuYVya4vA {
    --horizontal-padding: 2rem;
  }

  .zGYj5VVBBm7xLlN83wAZ {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1.25rem;
    grid-row-gap: 1.25rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .U31k8h2WgzfDuYVya4vA {
    --horizontal-padding: 1rem;

    margin-top: 3.5rem;
  }

  .zGYj5VVBBm7xLlN83wAZ {
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;
  }

  .X4hC6ZilcvtZIdFdz9D6 {
    font-size: 1rem;
    line-height: 1.375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentPagesSection/ContentPagesSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gBAAiB;EACjB,4BAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAAuC;EACvC,uBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAe;EACf,mBAAiB;AACnB;;AAEA;;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,wBAAqB;IACrB,qBAAkB;EACpB;AACF;;AAEA;;EACE;IACE,0BAA0B;;IAE1B,kBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAiB;EACnB;AACF","sourcesContent":[".contentPagesSection {\n  width: 100%;\n  background-color: var(--white);\n}\n\n.contentPagesSectionInner {\n  padding: 0 var(--horizontal-padding);\n  max-width: 1440px;\n  margin: 90px auto 0 auto;\n}\n\n.items {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-columns: minmax(100px, 225px);\n  grid-column-gap: 40px;\n  grid-row-gap: 48px;\n  margin: 48px 0;\n}\n\n.showMore {\n  color: var(--primary-link-color);\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@media (--desktop-large) {\n  .contentPagesSectionInner {\n    --horizontal-padding: 64px;\n  }\n}\n\n@media (--desktop-small) {\n  .contentPagesSectionInner {\n    --horizontal-padding: 48px;\n  }\n}\n\n@media (--tablet) {\n  .contentPagesSectionInner {\n    --horizontal-padding: 32px;\n  }\n\n  .items {\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n  }\n}\n\n@media (--mobile) {\n  .contentPagesSectionInner {\n    --horizontal-padding: 16px;\n\n    margin-top: 56px;\n  }\n\n  .items {\n    grid-template-columns: 1fr;\n    grid-row-gap: 16px;\n  }\n\n  .showMore {\n    font-size: 16px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentPagesSection": `o1Og27Rz6NSbTNhQKoZv`,
	"contentPagesSectionInner": `U31k8h2WgzfDuYVya4vA`,
	"items": `zGYj5VVBBm7xLlN83wAZ`,
	"showMore": `X4hC6ZilcvtZIdFdz9D6`
};
export default ___CSS_LOADER_EXPORT___;
